import React from 'react';
import UserProfileDisplay from '../../components/UserProfileDisplay.tsx';

function UserProfile() {
    return(
        <>
            <div className="p-4 md:p-8">
                <div className="max-w-6xl mx-auto">
                    <UserProfileDisplay />
                </div>
            </div>
        </>
    )
}
export default UserProfile
